import { useState } from 'react'
import { useLocation, Link } from 'react-router-dom'

export default function Measurements() {
  const location = useLocation()
  const { dress, fabric, sleeve, length, totalPrice } = location.state || {}

  const [measurements, setMeasurements] = useState({
    bust: '',
    waist: '',
    hips: '',
    shoulders: '',
    armhole: '',
    sleeveLength: '',
    dressLength: '',
    height: ''
  })

  const handleChange = (e) => {
    setMeasurements({ ...measurements, [e.target.name]: e.target.value })
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-2">Your Measurements</h1>
      <p className="text-gray-600 mb-8">Please provide accurate measurements for the perfect fit</p>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-2xl shadow-md">
          <div className="space-y-4">
            <div>
              <label className="block font-semibold mb-2">Bust (inches) *</label>
              <input
                type="number"
                name="bust"
                value={measurements.bust}
                onChange={handleChange}
                required
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 34"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Waist (inches) *</label>
              <input
                type="number"
                name="waist"
                value={measurements.waist}
                onChange={handleChange}
                required
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 28"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Hips (inches) *</label>
              <input
                type="number"
                name="hips"
                value={measurements.hips}
                onChange={handleChange}
                required
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 38"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Shoulders (inches)</label>
              <input
                type="number"
                name="shoulders"
                value={measurements.shoulders}
                onChange={handleChange}
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 14"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Armhole (inches)</label>
              <input
                type="number"
                name="armhole"
                value={measurements.armhole}
                onChange={handleChange}
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 7"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Sleeve Length (inches)</label>
              <input
                type="number"
                name="sleeveLength"
                value={measurements.sleeveLength}
                onChange={handleChange}
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 8"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Dress Length (inches)</label>
              <input
                type="number"
                name="dressLength"
                value={measurements.dressLength}
                onChange={handleChange}
                className="w-full border rounded-lg p-2"
                placeholder="e.g., 55"
              />
            </div>

            <div>
              <label className="block font-semibold mb-2">Height (feet/inches)</label>
              <input
                type="text"
                name="height"
                value={measurements.height}
                onChange={handleChange}
                className="w-full border rounded-lg p-2"
                placeholder='e.g., 5 feet 4 inches'
              />
            </div>
          </div>

          <Link
            to="/checkout"
            state={{ dress, fabric, sleeve, length, totalPrice, measurements }}
            className="block w-full bg-rose-600 text-white text-center px-6 py-3 rounded-full font-semibold hover:bg-rose-700 transition mt-6"
          >
            Continue to Checkout →
          </Link>
        </div>

        <div className="bg-rose-50 p-6 rounded-2xl">
          <h3 className="font-bold text-lg mb-4">How to Measure</h3>
          <div className="space-y-3 text-sm">
            <p><span className="font-semibold">Bust:</span> Measure around the fullest part of your chest</p>
            <p><span className="font-semibold">Waist:</span> Measure around the narrowest part of your waist</p>
            <p><span className="font-semibold">Hips:</span> Measure around the fullest part of your hips</p>
            <p><span className="font-semibold">Shoulders:</span> Measure from one shoulder edge to the other across the back</p>
            <p><span className="font-semibold">Armhole:</span> Measure around the widest part of your upper arm/shoulder joint</p>
            <p><span className="font-semibold">Sleeve Length:</span> Measure from shoulder tip to desired sleeve end</p>
            <p><span className="font-semibold">Dress Length:</span> Measure from shoulder to desired hemline</p>
            <p><span className="font-semibold">Height:</span> Your full height from head to toe</p>
          </div>
          <div className="mt-6 p-4 bg-white rounded-lg">
            <div className="text-center text-4xl mb-2">📏</div>
            <p className="text-xs text-gray-500 text-center">
              Use a soft measuring tape. Keep tape snug but not tight. <br />
              For best results, have someone help you measure.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
